import { addListenerToSelector, ready } from "@rootreeweb/js-lib";

import { initBreadCrumbs } from "./breadcumbs.js";
import { addExperiment } from "./experiments.js";
import { isFrench } from "./helpers.js";
import { initializeMoreInfoBlocks } from "./moreInfoBlocks.js";
import { init as navInit } from "./Nav.js";
import { rtIdentity } from "./rtIdentity.js";
import Search from "./search/Search.js";
import tracking from "./tracking.js";

/** The main function to run when the document is ready. */
function onReady(): void {
	new Search();
	navInit();
	rtIdentity();
	initializeMoreInfoBlocks();

	import("./popover.js").then((popover) => {
		popover.init();
	});

	if (document.querySelector(".nf-loading-spinner")) {
		import("./ninjaFormsBreadcrumbs.js").then(({ initializeNFBreadcrumbs }) => {
			initializeNFBreadcrumbs();
		});
	}
	if (document.querySelector(".tablepress")) {
		import("./tablepressFix.js").then((e) => {
			e.tablepressFix();
		});
	}

	if (document.querySelector(".rt-foundation-form-toggle")) {
		import("./foundation-form.js").then((e) => {
			e.default();
		});
	}

	if (document.querySelector(".rt-not-translated")) {
		import("./pageNotTranslated.js").then(({ pageNotTranslated }) => {
			pageNotTranslated();
		});
	}

	if (isFrench()) {
		import("./fr-hotfixes.js").then((e) => {
			e.default();
		});
	}

	if (document.querySelector("#rt-portfolio-data-source")) {
		import("./portfolio/index.js").then((e) => new e.default());
	}

	initBreadCrumbs();
	tracking();
	addExperiment("rt-experimental-css-bundle.css");
	addExperiment("rt-experimental-js-bundle.js");
	addListenerToSelector(".rt-print", "click", (e) => {
		e.preventDefault();
		window.print();
	});

	import("./accordions.js").then(({ initializeAccordions }) => {
		initializeAccordions();
	});
}

document.querySelector("body")?.classList.add("js");
ready(onReady);
